"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Shift = void 0;
/**
 * A shift: an activity or period of a day
 */
const day_date_1 = require("../value-objects/day-date");
const local_time_1 = require("../value-objects/local-time");
const price_1 = require("../value-objects/price");
const start_and_end_time_1 = require("../value-objects/start-and-end-time");
/** @deprecated */
class Shift {
    constructor(obj) {
        this.id = obj.id;
        this.childrenCanBePresent = obj.childrenCanBePresent;
        this.crewCanBePresent = obj.crewCanBePresent;
        this.description = obj.description;
        this.dayId = obj.dayId;
        this.kind = obj.kind;
        this.location = obj.location;
        this.price = new price_1.Price(obj.price);
        this.startAndEnd = obj.startAndEnd ? new start_and_end_time_1.StartAndEndTime(obj.startAndEnd) : undefined;
    }
    static sort(shifts) {
        return [...shifts].sort((a, b) => {
            if (day_date_1.DayDate.fromDayId(a.dayId).compareTo(day_date_1.DayDate.fromDayId(b.dayId)) !== 0) {
                return day_date_1.DayDate.fromDayId(a.dayId).compareTo(day_date_1.DayDate.fromDayId(b.dayId));
            }
            if (a.startAndEnd === undefined && b.startAndEnd === undefined) {
                return a.kind.localeCompare(b.kind);
            }
            else if (a.startAndEnd === undefined) {
                return 1; // corect? shifts with undefined startAndEnd should end up at the end
            }
            else if (b.startAndEnd === undefined) {
                return -1; // correct?
            }
            return new local_time_1.LocalTime(a.startAndEnd.start).compareTo(b.startAndEnd.start);
        });
    }
}
exports.Shift = Shift;
//# sourceMappingURL=shift.js.map